module.exports = __webpack_public_path__ + "img/link-to-the-past.c102648f.jpg";